.SDSCircularImage {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
  width: 100%;
  height: 100%;

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
